import { Request } from '@/classes/Request'

/**
 * Store a TransIT (TSEP-tokenized) credit card for the invited family,
 * token-authenticated. Payload shape matches TransitFormDialog's save payload
 * so it can be passed as the dialog's :save-handler.
 * POST /api/enrollment/invitation/{token}/funding-sources/transit-card
 */
export const enrollmentAddTransitCard = async (token: string, payload: object): Promise<void> => {
  await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/funding-sources/transit-card`,
    payload
  )
}
